var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bottom-bar-placeholder" },
    [
      _c("div", { staticClass: "bottom-bar flex" }, [
        _c(
          "div",
          { staticClass: "btn-item bg-FF", on: { click: _vm.goBack } },
          [_vm._v(" " + _vm._s("返回") + " ")]
        ),
        _vm.submitInfo.canRefuse
          ? _c(
              "div",
              { staticClass: "btn-item bg-FF", on: { click: _vm.refuse } },
              [_vm._v(" " + _vm._s(_vm.submitInfo.refuseName || "拒绝") + " ")]
            )
          : _vm._e(),
        _vm.submitInfo.canResend && _vm.groupIdQuery()
          ? _c(
              "div",
              { staticClass: "btn-item bg-FFDB43", on: { click: _vm.resend } },
              [_vm._v("重新发起")]
            )
          : _vm._e(),
        _vm.submitInfo.canHandle
          ? _c(
              "div",
              { staticClass: "btn-item bg-FFDB43", on: { click: _vm.agree } },
              [_vm._v(" " + _vm._s(_vm.submitInfo.agreeName || "同意") + " ")]
            )
          : _vm._e(),
        !_vm.processInstanceId
          ? _c(
              "div",
              { staticClass: "btn-item bg-FFDB43", on: { click: _vm.start } },
              [_vm._v(" " + _vm._s(_vm.submitInfo.agreeName || "发起") + " ")]
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "btn-item bg-FF" },
          [
            _c(
              "el-dropdown",
              { staticStyle: { width: "100%" }, attrs: { trigger: "click" } },
              [
                _c("div", [
                  _c("span", [_vm._v("更多")]),
                  _c("i", { staticClass: "el-icon-more font-30 m-l-10" }),
                ]),
                _c(
                  "el-dropdown-menu",
                  { attrs: { slot: "dropdown" }, slot: "dropdown" },
                  [
                    _vm.canSave()
                      ? _c(
                          "el-dropdown-item",
                          {
                            nativeOn: {
                              click: function ($event) {
                                return _vm.save()
                              },
                            },
                          },
                          [_vm._v("保存")]
                        )
                      : _vm._e(),
                    _c(
                      "el-dropdown-item",
                      {
                        nativeOn: {
                          click: function ($event) {
                            return _vm.comment.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("评论")]
                    ),
                    _vm.submitInfo.canAddMulti
                      ? _c(
                          "el-dropdown-item",
                          {
                            nativeOn: {
                              click: function ($event) {
                                return _vm.counterSign.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.submitInfo.addMultiName || "加签") +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.submitInfo.canAssignee
                      ? _c(
                          "el-dropdown-item",
                          {
                            nativeOn: {
                              click: function ($event) {
                                return _vm.assignee.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.submitInfo.assigneeName || "转办") +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.submitInfo.canRevoke
                      ? _c(
                          "el-dropdown-item",
                          {
                            nativeOn: {
                              click: function ($event) {
                                return _vm.revoke.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.submitInfo.revokeName || "撤销") +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.submitInfo.canReject
                      ? _c(
                          "el-dropdown-item",
                          {
                            nativeOn: {
                              click: function ($event) {
                                return _vm.reject.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.submitInfo.rejectName || "撤回") +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.submitInfo.canBack
                      ? _c(
                          "el-dropdown-item",
                          {
                            nativeOn: {
                              click: function ($event) {
                                return _vm.onBack.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.submitInfo.backName || "退回") +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.commentPopupShow,
            callback: function ($$v) {
              _vm.commentPopupShow = $$v
            },
            expression: "commentPopupShow",
          },
        },
        [
          _c("div", { staticStyle: { "overflow-y": "auto" } }, [
            _c(
              "div",
              { staticClass: "p-20" },
              [
                _c(
                  "van-form",
                  { ref: "commentForm", attrs: { "show-error": false } },
                  [
                    _c("van-field", {
                      staticClass: "b-r-20",
                      staticStyle: { border: "2px solid #ccc" },
                      attrs: {
                        name: "comment",
                        rules: [{ required: true, message: "请输入评论" }],
                        type: "textarea",
                        maxlength: "200",
                        rows: "3",
                        autosize: "",
                        "show-word-limit": "",
                        placeholder: "请输入评论",
                      },
                      model: {
                        value: _vm.commentForm.comment,
                        callback: function ($$v) {
                          _vm.$set(_vm.commentForm, "comment", $$v)
                        },
                        expression: "commentForm.comment",
                      },
                    }),
                    _c("span", { staticClass: "font-32" }, [
                      _vm._v("推荐回复:"),
                    ]),
                    _vm._l(_vm.replyList, function (item, index) {
                      return _c(
                        "van-tag",
                        {
                          key: index,
                          staticClass: "m-l-10",
                          attrs: { plain: "", type: "primary", size: "medium" },
                          on: {
                            click: function ($event) {
                              return _vm.addMentionComment(item)
                            },
                          },
                        },
                        [_vm._v(_vm._s(item.dictLabel) + " ")]
                      )
                    }),
                    _c("van-field", {
                      attrs: { name: "attachments", placeholder: "请上传附件" },
                      domProps: { value: _vm.commentForm.attachments },
                      scopedSlots: _vm._u([
                        {
                          key: "input",
                          fn: function () {
                            return [
                              _c("uploadFiles", {
                                attrs: {
                                  files: _vm.commentForm.attachments,
                                  "module-type": "comment",
                                },
                                on: { success: _vm.uploadSuccess },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                    _c("van-field", {
                      attrs: { name: "attachments", placeholder: "提醒关注" },
                      domProps: { value: _vm.commentForm.attachments },
                      scopedSlots: _vm._u([
                        {
                          key: "input",
                          fn: function () {
                            return [
                              _c(
                                "van-button",
                                {
                                  attrs: {
                                    round: "",
                                    block: "",
                                    type: "primary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.deptUserTreeAll.show = true
                                    },
                                  },
                                },
                                [_vm._v("@提醒谁关注")]
                              ),
                              _c(
                                "van-popup",
                                {
                                  attrs: {
                                    position: "bottom",
                                    "get-container": "body",
                                  },
                                  model: {
                                    value: _vm.deptUserTreeAll.show,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.deptUserTreeAll, "show", $$v)
                                    },
                                    expression: "deptUserTreeAll.show",
                                  },
                                },
                                [
                                  _c("van-nav-bar", {
                                    attrs: {
                                      title: "选择人员",
                                      "left-text": "取消",
                                      "right-text": "确定",
                                    },
                                    on: {
                                      "click-left": function ($event) {
                                        _vm.deptUserTreeAll.show = false
                                      },
                                      "click-right": _vm.commentPopupSubmit,
                                    },
                                  }),
                                  _c("van-search", {
                                    attrs: { clearable: "", shape: "round" },
                                    on: {
                                      input: function ($event) {
                                        return _vm.treeSearch(
                                          $event,
                                          _vm.$refs.tree
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.deptUserTreeAll.filterText,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.deptUserTreeAll,
                                          "filterText",
                                          $$v
                                        )
                                      },
                                      expression: "deptUserTreeAll.filterText",
                                    },
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "h-vh-50",
                                      staticStyle: { "overflow-y": "auto" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "p-10" },
                                        [
                                          _c("el-tree", {
                                            ref: "tree",
                                            attrs: {
                                              "node-key": "uuid",
                                              "check-strictly": "",
                                              data: _vm.deptUserTreeAll.data,
                                              "filter-node-method":
                                                _vm.filterNode,
                                              "check-on-click-node": "",
                                              "show-checkbox": "",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                    _vm.commentForm.userInfo.length > 0
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-wrap": "wrap",
                              "margin-top": "15rpx",
                            },
                          },
                          _vm._l(
                            _vm.commentForm.userInfo,
                            function (item, index) {
                              return _c(
                                "van-tag",
                                {
                                  key: index,
                                  staticClass: "m-l-10",
                                  attrs: {
                                    closeable: "",
                                    type: "warning",
                                    plain: "",
                                    size: "mini",
                                    closable: "",
                                  },
                                  on: {
                                    close: function ($event) {
                                      return _vm.closeUserInfo(item)
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s(item.label) + " ")]
                              )
                            }
                          ),
                          1
                        )
                      : _vm._e(),
                    _c(
                      "van-row",
                      { staticClass: "m-t-20", attrs: { gutter: 10 } },
                      [
                        _c(
                          "van-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "van-button",
                              {
                                attrs: {
                                  "native-type": "button",
                                  block: "",
                                  round: "",
                                },
                                on: { click: _vm.commentFormClose },
                              },
                              [_vm._v("取消")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "van-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "van-button",
                              {
                                attrs: {
                                  "native-type": "button",
                                  block: "",
                                  type: "primary",
                                  round: "",
                                },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.commentFormSubmit.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [_vm._v("提交 ")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom", "close-on-click-overlay": false },
          model: {
            value: _vm.submitFormShow,
            callback: function ($$v) {
              _vm.submitFormShow = $$v
            },
            expression: "submitFormShow",
          },
        },
        [
          _c(
            "div",
            { staticClass: "p-20", staticStyle: { "overflow-y": "auto" } },
            [
              _c(
                "van-form",
                { ref: "submitForm", attrs: { "show-error": false } },
                [
                  _c("van-field", {
                    staticClass: "b-r-20",
                    staticStyle: { border: "2px solid #ccc" },
                    attrs: {
                      name: "comments",
                      rules: [{ required: true, message: "请输入审批意见" }],
                      type: "textarea",
                      maxlength: "200",
                      rows: "3",
                      autosize: "",
                      "show-word-limit": "",
                      placeholder:
                        _vm.submitType == "assignee"
                          ? "请输入转办意见"
                          : "请输入审批意见",
                    },
                    model: {
                      value: _vm.submitFormData.comments,
                      callback: function ($$v) {
                        _vm.$set(_vm.submitFormData, "comments", $$v)
                      },
                      expression: "submitFormData.comments",
                    },
                  }),
                  _vm.submitType !== "assignee"
                    ? _c("span", { staticClass: "font-32" }, [
                        _vm._v("推荐回复:"),
                      ])
                    : _vm._e(),
                  _vm._l(_vm.replyList, function (item, index) {
                    return _c(
                      "van-tag",
                      {
                        key: index,
                        staticClass: "m-l-10",
                        attrs: { plain: "", type: "primary", size: "medium" },
                        on: {
                          click: function ($event) {
                            return _vm.addComment(item)
                          },
                        },
                      },
                      [_vm._v(_vm._s(item.dictLabel) + " ")]
                    )
                  }),
                  _vm.submitType == "assignee"
                    ? _c("van-field", {
                        attrs: {
                          rules: [{ required: true, message: "请选择转办人" }],
                          value: _vm.submitFormData.transferUserInfoStr,
                          name: "transferUserInfoStr",
                          placeholder: "转办",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "input",
                              fn: function () {
                                return [
                                  _vm.submitFormData.transferUserInfo
                                    ? _c("div", { staticClass: "flex-1" }, [
                                        _vm._v(
                                          "转办人：" +
                                            _vm._s(
                                              _vm.submitFormData
                                                .transferUserInfo.label
                                            ) +
                                            " "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _c(
                                    "van-button",
                                    {
                                      staticClass: "flex-1",
                                      attrs: {
                                        "native-type": "button",
                                        round: "",
                                        block: "",
                                        type: "primary",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.deptUserTreeAll.show = true
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.submitFormData.transferUserInfo
                                            ? "重新选择"
                                            : "选择转办人"
                                        ) + " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "van-popup",
                                    {
                                      attrs: {
                                        position: "bottom",
                                        "get-container": "body",
                                      },
                                      model: {
                                        value: _vm.deptUserTreeAll.show,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.deptUserTreeAll,
                                            "show",
                                            $$v
                                          )
                                        },
                                        expression: "deptUserTreeAll.show",
                                      },
                                    },
                                    [
                                      _c("van-nav-bar", {
                                        attrs: {
                                          title: "选择人员",
                                          "left-text": "取消",
                                          "right-text": "确定",
                                        },
                                        on: {
                                          "click-left": function ($event) {
                                            _vm.deptUserTreeAll.show = false
                                          },
                                          "click-right":
                                            _vm.assigneePopupSubmit,
                                        },
                                      }),
                                      _c("van-search", {
                                        attrs: {
                                          clearable: "",
                                          shape: "round",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.treeSearch(
                                              $event,
                                              _vm.$refs.assigneeTree
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.deptUserTreeAll.filterText,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.deptUserTreeAll,
                                              "filterText",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "deptUserTreeAll.filterText",
                                        },
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "h-vh-50",
                                          staticStyle: { "overflow-y": "auto" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "p-10" },
                                            [
                                              _c("el-tree", {
                                                ref: "assigneeTree",
                                                attrs: {
                                                  "node-key": "uuid",
                                                  "check-strictly": "",
                                                  data: _vm.deptUserTreeAll
                                                    .data,
                                                  "filter-node-method":
                                                    _vm.filterNode,
                                                  "check-on-click-node": "",
                                                  "show-checkbox": "",
                                                },
                                                on: {
                                                  "check-change": function (
                                                    $event
                                                  ) {
                                                    return _vm.approverCheckChange(
                                                      $event,
                                                      _vm.$refs.assigneeTree
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1527369730
                        ),
                      })
                    : _vm._e(),
                  _c(
                    "van-row",
                    { staticClass: "m-t-20", attrs: { gutter: 10 } },
                    [
                      _c(
                        "van-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "van-button",
                            {
                              attrs: {
                                "native-type": "button",
                                block: "",
                                round: "",
                              },
                              on: { click: _vm.submitFormCancel },
                            },
                            [_vm._v("取消")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "van-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "van-button",
                            {
                              attrs: {
                                "native-type": "button",
                                block: "",
                                type: "primary",
                                round: "",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.submitForm.apply(null, arguments)
                                },
                              },
                            },
                            [_vm._v("提交")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom", "close-on-click-overlay": false },
          model: {
            value: _vm.counterSignShow,
            callback: function ($$v) {
              _vm.counterSignShow = $$v
            },
            expression: "counterSignShow",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "p-20 counterSign-container",
              staticStyle: { "overflow-y": "auto" },
            },
            [
              _c(
                "van-form",
                {
                  ref: "counterSignForm",
                  attrs: {
                    "error-message-align": "right",
                    "show-error": false,
                  },
                },
                [
                  _c("van-field", {
                    staticClass: "b-r-20",
                    staticStyle: { border: "2px solid #ccc" },
                    attrs: {
                      required: "",
                      name: "comments",
                      rules: [{ required: true, message: "请输入意见" }],
                      type: "textarea",
                      maxlength: "200",
                      rows: "3",
                      autosize: "",
                      "show-word-limit": "",
                      placeholder: "请输入加签意见",
                    },
                    model: {
                      value: _vm.counterSignForm.comments,
                      callback: function ($$v) {
                        _vm.$set(_vm.counterSignForm, "comments", $$v)
                      },
                      expression: "counterSignForm.comments",
                    },
                  }),
                  _vm.counterSignForm.multiAddUserInfo.length > 0
                    ? _c(
                        "div",
                        { staticClass: "font-30 m-t-10" },
                        [
                          _c("span", [_vm._v("加签人：")]),
                          _vm._l(
                            _vm.counterSignForm.multiAddUserInfo,
                            function (item, index) {
                              return _c(
                                "van-tag",
                                {
                                  key: index,
                                  staticClass: "m-l-5",
                                  attrs: { type: "primary", size: "medium" },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(item.label || item.name) + " "
                                  ),
                                ]
                              )
                            }
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c("van-field", {
                    attrs: {
                      required: "",
                      name: "multiAddUserInfo",
                      placeholder: "加签",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "input",
                        fn: function () {
                          return [
                            _c(
                              "van-button",
                              {
                                attrs: {
                                  "native-type": "button",
                                  round: "",
                                  block: "",
                                  type: "primary",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.deptUserTreeAll.show = true
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.counterSignForm.multiAddUserInfo
                                        .length > 0
                                        ? "重新选择"
                                        : "选择加签人"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "van-popup",
                              {
                                attrs: {
                                  position: "bottom",
                                  "get-container": "body",
                                },
                                model: {
                                  value: _vm.deptUserTreeAll.show,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.deptUserTreeAll, "show", $$v)
                                  },
                                  expression: "deptUserTreeAll.show",
                                },
                              },
                              [
                                _c("van-nav-bar", {
                                  attrs: {
                                    title: "选择人员",
                                    "left-text": "取消",
                                    "right-text": "确定",
                                  },
                                  on: {
                                    "click-left": function ($event) {
                                      _vm.deptUserTreeAll.show = false
                                    },
                                    "click-right": _vm.counterSignPopupSubmit,
                                  },
                                }),
                                _c("van-search", {
                                  attrs: { clearable: "", shape: "round" },
                                  on: {
                                    input: function ($event) {
                                      return _vm.treeSearch(
                                        $event,
                                        _vm.$refs.counterSignTree
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.deptUserTreeAll.filterText,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.deptUserTreeAll,
                                        "filterText",
                                        $$v
                                      )
                                    },
                                    expression: "deptUserTreeAll.filterText",
                                  },
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass: "h-vh-50",
                                    staticStyle: { "overflow-y": "auto" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "p-10" },
                                      [
                                        _c("el-tree", {
                                          ref: "counterSignTree",
                                          attrs: {
                                            "node-key": "uuid",
                                            "check-strictly": "",
                                            data: _vm.deptUserTreeAll.data,
                                            "filter-node-method":
                                              _vm.filterNode,
                                            "check-on-click-node": "",
                                            "show-checkbox": "",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                  _c(
                    "van-row",
                    { staticClass: "m-t-20", attrs: { gutter: 10 } },
                    [
                      _c(
                        "van-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "van-button",
                            {
                              attrs: {
                                "native-type": "button",
                                block: "",
                                round: "",
                              },
                              on: { click: _vm.counterSignCancel },
                            },
                            [_vm._v("取消")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "van-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "van-button",
                            {
                              attrs: {
                                "native-type": "button",
                                block: "",
                                type: "primary",
                                round: "",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.counterSignSubmit.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [_vm._v("提交 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "van-popup",
        {
          staticStyle: { width: "80%" },
          attrs: { round: "" },
          model: {
            value: _vm.relevanceFlowShow,
            callback: function ($$v) {
              _vm.relevanceFlowShow = $$v
            },
            expression: "relevanceFlowShow",
          },
        },
        [
          _c(
            "div",
            { staticClass: "p-l-20" },
            [
              _c("titleBar", { attrs: { title: "请选择关联流程" } }),
              _c(
                "div",
                { staticClass: "mt10" },
                [
                  _c(
                    "van-grid",
                    { attrs: { "column-num": 2 } },
                    _vm._l(_vm.userFlowList, function (item, i) {
                      return _c(
                        "van-grid-item",
                        {
                          key: i,
                          on: {
                            click: function ($event) {
                              return _vm.userFlowChange(item)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "avatar" }, [
                            _vm._v(_vm._s(item.templateName.substring(0, 1))),
                          ]),
                          _c("div", { staticClass: "first-title m-t-20" }, [
                            _vm._v(_vm._s(item.templateName)),
                          ]),
                          _c("div", { staticClass: "second-title m-t-20" }, [
                            _vm._v(_vm._s(item.remark)),
                          ]),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }